import {defineAsyncComponent} from 'vue';
import AnnouncementBar from './AnnouncementBar.vue';
import SearchBar from './SearchBar.vue';
import CartIcons from './CartIcons.vue';
import CartDrawer from './CartDrawer.vue';
import VModal from './VModal.vue';

import ProductGallerySkeleton from '../skeleton/ProductGallerySkeleton.vue';
import ProductStartersetSkeleton from '../skeleton/ProductStartersetSkeleton.vue';

export default {
  components: {
    AnnouncementBar,
    SearchBar,
    CartIcons,
    CartDrawer,
    VModal,
    StorePicker: defineAsyncComponent(() => import('./StorePicker.vue')),
    VAccordion: defineAsyncComponent(() => import('./VAccordion.vue')),
    VGrid: defineAsyncComponent(() => import('./VGrid.vue')),
    VIcon: defineAsyncComponent(() => import('./VIcon.vue')),
    VImage: defineAsyncComponent(() => import('./VImage.vue')),
    VVideo: defineAsyncComponent(() => import('./VVideo.vue')),
    GeoPopup: defineAsyncComponent(() => import('./GeoPopup.vue')),
    ProductGallery: defineAsyncComponent({
      loader: () => import('./ProductGallery.vue'),
      loadingComponent: ProductGallerySkeleton,
    }),
    ProductsLastViewed: defineAsyncComponent(() => import('./ProductsLastViewed.vue')),
    ProductRecommendations: defineAsyncComponent(() => import('./ProductRecommendations.vue')),
    ProductStarterset: defineAsyncComponent({
      loader: () => import('./ProductStarterset.vue'),
      loadingComponent: ProductStartersetSkeleton,
    }),
    LogoSlider: defineAsyncComponent(() => import('./LogoSlider.vue')),
    ProductSelectionDrawer: defineAsyncComponent(() => import('./ProductSelectionDrawer.vue')),
    CustomDiscounts: defineAsyncComponent(() => import('./CustomDiscounts.vue')),
  },
};
